import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Layout from "components/Layout";
import Modal from "components/Modal";
import PayflowIntegrationCard from "components/Integrations/PayflowIntegrationCard";
import { showModal, hideModal } from "actions/modalActions";
import { isAdmin } from "utils/utils";
import { Redirect } from "react-router-dom";

class Integrations extends React.Component {
	closeModal = () => {
		this.props.hideModal();
	};

	render() {
		const { t } = this.props;

		if (!isAdmin()) {
			return <Redirect to="/settings" />;
		}

		return (
			<>
				<Layout configSidebar={true} className="page-integrations">
					<div className="heading">
						<h1 className="title">{t("settings.title")}</h1>
					</div>

					<div className="integrations-content">
						<h2 className="integrations-content__title">
							{t("integrations.title")}
						</h2>
						<div className="integrations-grid">
							<div className="integrations-grid__item">
								<PayflowIntegrationCard
									showModal={this.props.showModal}
									hideModal={this.props.hideModal}
								/>
							</div>
						</div>
					</div>
				</Layout>

				<Modal hideModal={this.closeModal} />
			</>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
});

export default connect(
	null,
	mapDispatchToProps
)(withTranslation()(Integrations));
